// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1Fzpv","itemTitle":"ClientEmergencyInfo_itemTitle__dS3se","itemText":"ClientEmergencyInfo_itemText__13sXB"};